

// import React from "react";
// import image1 from "../img/aaaservices/sandeep.png";
// import image2 from "../img/banner/onner2.png";

// const CardComponent = () => {
//   const styles = {
//     cardContainer: {
//       display: "flex",
//       justifyContent: "center",
//       gap: "50px", // Added space between cards
//       padding: "20px",
//       flexWrap: "wrap",
//     },
//     card: {
//       width: "100%",
//       maxWidth: "400px",
//       position: "relative",
//       borderRadius: "10px",
//       overflow: "hidden",
//       border: "1px solid rgb(235, 195, 101)", // Added yellow border
//     },
//     cardImage: {
//       width: "100%",
//       height: "462px",
//       objectFit: "cover",
//     },
//     cardInfo: {
//       position: "absolute",
//       bottom: "0",
//       width: "100%",
//       background: "rgba(0, 0, 0, 0.7)",
//       color: "white",
//       textAlign: "center",
//       padding: "10px",
//       transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
//     },
//     cardInfoHover: {
//       animation: "blink 1s infinite", // Adding blink animation
//     },
//     cardTitle: {
//       margin: "0",
//       fontSize: "18px",
//       color:'rgb(235, 195, 101)'
//     },
//     cardSubtitle: {
//       margin: "0",
//       fontSize: "14px",
//     },

//   };


//   return (

//     <div className="containersssss" style={{ maxWidth: '90%', margin: '0 auto',marginTop:'-77px',marginBottom:'20px' }}> {/* Increased width */}
//        <div style={{ textAlign: 'center', marginBottom: '30px', fontFamily: 'lato,sans,serif', fontSize: '48px', }}>
//             <div class="text-center"> <h1 style={{ color: "#000", fontSize: '48px', display: 'inline-block', position: 'relative', fontFamily: 'lato,sans,serif', textAlign: 'center' }}> Our <span style={{ color: "rgb(235, 195, 101)" }}>Leadership</span>
//             </h1></div>
//             <div
//               style={{
//                 width: '200px', // Adjust the width of the line
//                height: '2px', // Thickness of the line
//                 backgroundColor: '#000', // Black color
//                 margin: '10px auto 0', // Center alignment and spacing
//                 marginTop: '-10px'
//               }}
//            ></div>
//           </div>
//     <div style={styles.cardContainer}>


//       <div
//         style={styles.card}
//         onMouseEnter={(e) => e.currentTarget.children[1].classList.add("blink")}
//         onMouseLeave={(e) => e.currentTarget.children[1].classList.remove("blink")}
//       >
//         <img src={image1} alt="Card 1" style={styles.cardImage} />
//         <div style={styles.cardInfo} className="card-info">
//           <h3 style={styles.cardTitle}>SANDEEP D</h3>
//           <p style={styles.cardSubtitle}>PROPRIETOR</p>
//         </div>
//       </div>
//       <div
//         style={styles.card}
//         onMouseEnter={(e) => e.currentTarget.children[1].classList.add("blink")}
//         onMouseLeave={(e) => e.currentTarget.children[1].classList.remove("blink")}
//       >
//         <img src={image2} alt="Card 2" style={styles.cardImage} />
//         <div style={styles.cardInfo} className="card-info">
//           <h3 style={styles.cardTitle}>JAI MK</h3>
//           <p style={styles.cardSubtitle}>OPERATION HEAD</p>
//         </div>
//       </div>
//     </div>
//     </div>
//   );
// };

// export default CardComponent;

// // Add this CSS to your styles to make the blinking effect
// const styleSheet = document.createElement("style");
// styleSheet.type = "text/css";
// styleSheet.innerText = `
//   @keyframes blink {
//     0% { opacity: 1; }
//     50% { opacity: 0.5; }
//     100% { opacity: 1; }
//   }

//   .blink {

//   }
//      @media (max-width: 768px) {
//     .card-container {
//       flex-direction: column;
//       align-items: center;
//     }
//     .card {
//       max-width: 100%;
//     }

//      @media (max-width: 425px) {
//     .card-container {
//       flex-direction: column;
//       align-items: center;
//     }
//     .card {
//       max-width: 100%;
//     }

//      @media (max-width: 320px) {
//     .card-container {
//       flex-direction: column;
//       align-items: center;
//     }
//     .card {
//       max-width: 100%;
//     }
// `;
// document.head.appendChild(styleSheet);



// import React, { useEffect, useState } from "react";
// import madamImg from "../img/banner/onner2.png"; // import your images
// import sirImg from "../img/aaaservices/sandeep.png";
// import bgImg from "../img/aaaservices/aIRPORTJ.jpg";



// const OurPhilosophySection = () => {
//   const [animate, setAnimate] = useState(false);


//   const styles = {
//   container: {
//     padding: "50px 20px",
//     fontFamily: "Arial, sans-serif",
//     textAlign: "center",
//   },
  
//   // heading: {
//   //   fontSize: "40px",
//   //   fontWeight: "bold",
//   //   marginBottom: "40px",
//   //   textAlign:'center',
//   //   color: "#222",
//   // },
//    underline : {
//   width: "200px",
//   height: "2px",
//   backgroundColor: "#000",
//   margin: "10px auto",
//   marginTop:'-20px'
// },
//   wrapper: {
//     display: "flex",
//     gap: "40px",
//     alignItems: "center",
//     justifyContent: "center",
//     flexWrap: "wrap",
//     maxWidth: "1200px", // ✅ max width set
//     margin: "0 auto",
//   },
//   left: {
//     flex: "1",
//     minWidth: "280px",
//     maxWidth: "500px", // ✅ image ko control kiya
//   },
//   right: {
//     flex: "1",
//     minWidth: "280px",
//   },
//   imageWrapper: {
//     position: "relative",
//     overflow: "hidden",
//     borderRadius: "16px",
//     // boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
//   },
//   image: {
//     width: "100%",
//     height: "auto",
//     borderRadius: "16px",
//   },
//   overlay: {
//     position: "absolute",
//     bottom: "0",
//     left: "0",
//     right: "0",
//     // background: "rgba(0, 0, 0, 0.6)",
//     color: "#fff",
//     padding: "20px",
//     borderRadius: "0 0 16px 16px",
//     textAlign: "left",
//   },
//   overlayTitle: {
//     fontSize: "25px",
//     marginBottom: "6px",
//     color:'gold',
//     fontWeight: "bold",
//   },
//  overlayText: {
//   fontSize: "25px",
//   lineHeight: "1.4",
//   fontWeight: "bold",
//   textShadow: "2px 2px 4px rgba(0,0,0,0.7)", // ✅ shadow added
//   color:"gold",
// },

//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", // ✅ smaller boxes
//     gap: "15px",
//   },
//   card: {
//     backgroundColor: "#FFD54F",
//     padding: "14px",
//     borderRadius: "10px",
//     fontSize: "14px",
//     fontWeight: "500",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//   },
//   dot: {
//     marginRight: "6px",
//     color: "#000",
//     fontSize: "14px",
//   },
// };

//   useEffect(() => {
//     const style = document.createElement("style");
//     style.innerHTML = `
//       .team-section, .additional-section {
//         width: 100%;
//         padding: 40px 20px;
//       }

//       /* Backgrounds */
//       .team-section {
//         background: url(${bgImg}) center/cover fixed no-repeat;
//       }
//       .additional-section {
//         background: url(${bgImg}) center/cover fixed no-repeat;
//       }

//       .section-heading {
//         text-align: center;
//         font-size: 40px;
//         margin-bottom: 50px;
//         color: black;
//         font-weight: bold;
//       }

//       .team-container, .additional-container {
//         display: flex;
//         flex-wrap: wrap;
//         align-items: center;
//         justify-content: center;
//         max-width: 1200px;
//         margin: 0 auto;
//         gap: 40px;
//         padding: 20px;
//       }

//       /* Card wrapper */
//       .team-wrapper, .additional-wrapper {
//         display: flex;
//         flex: 1;
//         flex-direction: row;
//         background: linear-gradient(135deg, #e3a84a, #e1b963);
//         padding: 20px;
//         gap: 20px;
//         border-radius: 15px;
//          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
//         color: white;
//         width: 100%;
//         align-items: center;
//         transition: transform 0.4s ease;
//       }
//       .team-wrapper:hover, .additional-wrapper:hover {
//         transform: translateY(-8px);
//       }

//       /* Content */
//       .team-content, .additional-content {
//         flex: 1;
//         min-width: 50%;
//         padding: 20px;
//       }

//       .team-image-container, .additional-image-container {
//         width: 300px;
//         height: 380px;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         flex-shrink: 0;
//       }

//       /* Animation entry */
//       .team-info, .additional-info {
//         transform: translateX(-120px);
//         opacity: 0;
//         transition: all 1s ease;
//       }

//       .team-image, .additional-image {
//         transform: translateX(120px);
//         opacity: 0;
//         transition: all 1s ease;
//       }

//       .animate .team-info, .animate .additional-info {
//         transform: translateX(0);
//         opacity: 1;
//       }

//       .animate .team-image, .animate .additional-image {
//         transform: translateX(0);
//         opacity: 1;
//       }

//       /* Text */
//       .team-name, .additional-name {
//         font-size: 2rem;
//         font-weight: 700;
//         margin-bottom: 10px;
//         color: white;
//       }
//       .team-designation, .additional-designation {
//         font-size: 1.2rem;
//         color: white;
//         margin-bottom: 20px;
//         font-weight: 600;
//       }
//       .team-description, .additional-description {
//         font-size: 18px;
//         line-height: 1.6;
//         color: white;
//         margin-bottom: 30px;
//       }

//       .social-links, .additional-social-links {
//         display: flex;
//         justify-content: flex-start;
//         gap: 20px;
//       }
//       .social-links a, .additional-social-links a {
//         color: #fff;
//         font-size: 1.5rem;
//         transition: all 0.3s ease;
//       }
//       .social-links a:hover, .additional-social-links a:hover {
//         color: #222;
//         transform: translateY(-3px) scale(1.1);
//       }

//       /* Image */
//       .team-image img, .additional-image img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover;
//         border-radius: 15px;
//         // box-shadow: 0 6px 15px rgba(0,0,0,0.25);
//       }

//       .team-image img, .additional-imageyy img {
//         // width: 100%;
//         height: 100%;
//         object-fit: cover;
//         border-radius: 15px;
//         // box-shadow: 0 6px 15px rgba(0,0,0,0.25);
//       }

//       /* Responsive */
//       @media (max-width: 992px) {
//         .team-wrapper, .additional-wrapper {
//           flex-direction: column;
//           text-align: center;
//         }
//         .team-content, .additional-content {
//           width: 100%;
//           min-width: 100%;
//           padding: 20px;
//         }
//         .team-image-container, .additional-image-container {
//           width: 280px;
//           height: 340px;
//           margin: 0 auto;
//         }
//         .team-info, .additional-info {
//           transform: translateY(60px);
//         }
//         .team-image, .additional-image {
//           transform: translateY(-60px);
//         }
//         .animate .team-info, .animate .additional-info,
//         .animate .team-image, .animate .additional-image {
//           transform: translateY(0);
//         }
//         .social-links, .additional-social-links {
//           justify-content: center;
//         }
//       }

//       @media (max-width: 768px) {
//         .section-heading {
//           font-size: 2rem;
//           margin-bottom: 30px;
//         }
//         .team-name, .additional-name {
//           font-size: 1.7rem;
//         }
//         .team-description, .additional-description {
//           font-size: 16px;
//           text-align: justify;
//         }
//         .team-image-container, .additional-image-container {
//           width: 240px;
//           height: 300px;
//         }
//       }

//       @media (max-width: 576px) {
//         .section-heading {
//           font-size: 1.6rem;
//         }
//         .team-wrapper, .additional-wrapper {
//           padding: 15px;
//         }
//         .team-image-container, .additional-image-container {
//           width: 200px;
//           height: 250px;
//         }
//       }
//     `;
//     document.head.appendChild(style);

//     setTimeout(() => setAnimate(true), 300);

//     return () => document.head.removeChild(style);
//   }, []);

//   return (
//     <>
//       {/* Team Section */}
//       <div className={`team-section ${animate ? "animate" : ""}`}>
//         <h1 style={{fontFamily:'roboto sans,serif',fontSize:'40px',color:"white",fontWeight:'bold',textAlign:'center'}} >
//           Meet Our <span style={{ color: "rgb(235, 195, 101)" }}>Team</span>
//        </h1>
//        <div style={styles.underline}></div>

//         <div className="team-container">
//           <div className="team-wrapper">
//             <div className="team-content">
//               <div className="team-info">
//                 <h3 className="additional-name">Jai MK</h3>
//           <p className="additional-designation">Operations</p>
//           <p className="additional-description">
//             Jai MK oversees the day-to-day operations, ensuring seamless
//             coordination between teams and delivering consistent results.
//             With a strong focus on efficiency and process improvement,
//             he plays a vital role in maintaining the company’s high standards
//             of service and operational excellence. His leadership in operations
//             helps drive both productivity and customer satisfaction.
//           </p>
//                 <div className="social-links">
//                   <a href="#"><i className="bi bi-twitter-x"></i></a>
//                   <a href="#"><i className="bi bi-instagram"></i></a>
//                   <a href="#"><i className="bi bi-facebook"></i></a>
//                 </div>
//               </div>
//             </div>

//             <div className="team-image-container">
//               <div className="team-image">
//                 <img  src={madamImg} alt="jai mk" className="jaimk" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Additional Section */}
//       <div className={`additional-section ${animate ? "animate" : ""}`}>
//         <div className="additional-container">
//           <div className="additional-wrapper">
//             <div className="additional-image-container">
//               <div className="additional-image">
//                 <img src={sirImg} alt="sanddep" />
//               </div>
//             </div>

//             <div className="additional-content">
//               <div className="additional-info">
//                 <h3 className="additional-name">Sandeep D</h3>
//                 <p className="additional-designation">
//                   Proprietor
//                 </p>
//                 <p className="additional-description">
//                   Sandeep D is the driving force behind our logistics operations,
//                   bringing years of expertise in supply chain management and business leadership.
//                   As Proprietor of a leading logistics company, he ensures efficient, reliable,
//                   and customer-focused solutions that strengthen our overall vision.
//                   His commitment to operational excellence and innovation has played a crucial role
//                   in expanding our network and delivering value to clients across industries.
//                 </p>

//                 <div className="additional-social-links">
//                   <a href="#"><i className="bi bi-twitter-x"></i></a>
//                   <a href="#"><i className="bi bi-instagram"></i></a>
//                   <a href="#"><i className="bi bi-facebook"></i></a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default OurPhilosophySection;



import React, { useEffect, useState } from "react";
import madamImg from "../img/banner/onner2.png";
import sirImg from "../img/aaaservices/sandeep.png";
import bgImg from "../img/aaaservices/aIRPORTJ.jpg";

const OurPhilosophySection = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setTimeout(() => setAnimate(true), 300);
  }, []);

  return (
    <div style={containerStyle}>
      {/* Team Heading */}
      <div style={headingContainerStyle}>
        <h1 style={headingStyle}>
          Meet Our <span style={accentStyle}>Team</span>
        </h1>
        <div style={underlineStyle}></div>
      </div>

      {/* Team Members Section */}
      <div style={teamContainerStyle}>
        {/* First Team Member */}
        <div style={{...cardWrapperStyle, flexDirection: 'row'}} className={animate ? "animate" : ""}>
          <div style={contentStyle}>
            <h3 style={nameStyle}>Jai MK</h3>
            <p style={designationStyle}>Operations</p>
            <p style={descriptionStyle}>
              Jai MK oversees the day-to-day operations, ensuring seamless
              coordination between teams and delivering consistent results.
              With a strong focus on efficiency and process improvement,
              he plays a vital role in maintaining the company's high standards
              of service and operational excellence.
            </p>
            <div style={socialLinksStyle}>
              <a href="#" style={socialLinkStyle}><i className="bi bi-twitter-x"></i></a>
              <a href="#" style={socialLinkStyle}><i className="bi bi-instagram"></i></a>
              <a href="#" style={socialLinkStyle}><i className="bi bi-facebook"></i></a>
            </div>
          </div>
          
          <div style={imageContainerStyle}>
            <img src={madamImg} alt="Jai MK" style={imageStyle} />
          </div>
        </div>

        {/* Second Team Member - reversed on desktop */}
        <div style={{...cardWrapperStyle, flexDirection: 'row-reverse'}} className={animate ? "animate" : ""}>
          <div style={contentStyle}>
            <h3 style={nameStyle}>Sandeep D</h3>
            <p style={designationStyle}>Proprietor</p>
            <p style={descriptionStyle}>
              Sandeep D is the driving force behind our logistics operations,
              bringing years of expertise in supply chain management and business leadership.
              As Proprietor of a leading logistics company, he ensures efficient, reliable,
              and customer-focused solutions that strengthen our overall vision.
            </p>
            <div style={socialLinksStyle}>
              <a href="#" style={socialLinkStyle}><i className="bi bi-twitter-x"></i></a>
              <a href="#" style={socialLinkStyle}><i className="bi bi-instagram"></i></a>
              <a href="#" style={socialLinkStyle}><i className="bi bi-facebook"></i></a>
            </div>
          </div>
          
          <div style={imageContainerStyle}>
            <img src={sirImg} alt="Sandeep D" style={imageStyle} />
          </div>
        </div>
      </div>

      <style jsx>{`
        @media (max-width: 768px) {
          .team-card {
            flex-direction: column !important;
          }
            .animate{
             flex-direction: column !important;
            }
        }
      `}</style>
    </div>
  );
};

// Styles
const containerStyle = {
  padding: "40px 20px",
  fontFamily: "'Roboto', Arial, sans-serif",
  background: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${bgImg}) center/cover fixed no-repeat`,
  color: "#fff",
};

const headingContainerStyle = {
  textAlign: "center",
  marginBottom: "50px"
};

const headingStyle = {
  fontSize: "clamp(32px, 5vw, 48px)",
  fontWeight: "bold",
  marginBottom: "10px",
  color: "white"
};

const accentStyle = {
  color: "rgb(235, 195, 101)"
};

const underlineStyle = {
  width: "200px",
  height: "2px",
  backgroundColor: "rgb(235, 195, 101)",
  margin: "0 auto",
};

const teamContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "60px",
  maxWidth: "1200px",
  margin: "0 auto",
};

const cardWrapperStyle = {
  display: "flex",
  background: "linear-gradient(135deg, rgba(227, 168, 74, 0.9), rgba(225, 185, 99, 0.9))",
  borderRadius: "16px",
  padding: "30px",
  // boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
  alignItems: "center",
  gap: "40px",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  overflow: "hidden"
};

const contentStyle = {
  flex: "1",
  padding: "20px",
};

const nameStyle = {
  fontSize: "clamp(24px, 4vw, 32px)",
  fontWeight: "700",
  marginBottom: "8px",
  color: "white"
};

const designationStyle = {
  fontSize: "clamp(16px, 3vw, 20px)",
  color: "white",
  marginBottom: "20px",
  fontWeight: "600"
};

const descriptionStyle = {
  fontSize: "clamp(14px, 2.5vw, 18px)",
  lineHeight: "1.6",
  color: "white",
  marginBottom: "30px",
  textAlign: "justify"
};

const socialLinksStyle = {
  display: "flex",
  gap: "20px"
};

const socialLinkStyle = {
  color: "#fff",
  fontSize: "24px",
  transition: "all 0.3s ease"
};

const imageContainerStyle = {
  flex: "0 0 300px",
  height: "380px",
  borderRadius: "12px",
  overflow: "hidden",
  // boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
  position: "relative"
};

const imageStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  transition: "transform 0.5s ease"
};

// Media query styles are applied via the style tag in the component

export default OurPhilosophySection;
